/* eslint-disable */
import TopbarMain from "./TopbarMain";
import TopbarCategories from "./TopbarCategories";
import HeroBanner from "../Body/HeroBanner";

export default function EcommerceNavbar() {
  return (
    <div className="w-full">

      {/* SECCIÓN FIJA */}
      <div className="fixed top-0 w-full z-50">
        <TopbarMain />
        <TopbarCategories />             
      </div>

    </div>
  );
}
